import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import {
	NavigationPropType,
	PromoBlockPropType,
	RubricPropType,
	TextBlockPropType
} from 'propTypes/common';

import { Layout, LayoutBlock } from 'components/Layout';
import Container from 'components/Container';
import MainPromoBlocks from 'components/promoBlocks/MainPromoBlocks';
import Search from 'components/landings/Search';

import Broadcast from './components/Broadcast';
import Catalogs from './components/Catalogs';
import Movies from './components/Movies';
import Persons from './components/Persons';
import SpecialProjects from './components/SpecialProjects';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { assetPrefix }
} = getConfig();

const WatchTemplate = ({
	menu,
	blocks: {
		broadcast,
		concerts,
		cinemaCompilations,
		filmsAndPerformances,
		lections,
		promoBlocks,
		specialProjects,
		searchPrompts,
		...blocks
	},
	counters,
	textBlocks,
	rubric,
	text,
	topPromoBlock
}) => {
	const {
		broadcastText,
		catalogsText,
		concertsText,
		filmsAndPerformancesText,
		lectionsText,
		personsText,
		specialProjectsText
	} = textBlocks;
	const [firstCompilation, secondCompilation] = cinemaCompilations || [];

	return (
		<Layout menu={menu} rubric={rubric} topPromoBlock={topPromoBlock}>
			<LayoutBlock>
				<Search
					title="Смотреть"
					images={[
						`${assetPrefix}images/landings/watch_banner_left_part.svg`,
						`${assetPrefix}images/landings/watch_banner_right_part.svg`
					]}
					mainImage="right"
					backgroundMobileSize="small"
					imageClassName={styles.image}
					tags={searchPrompts}
					subtitle={text}
				/>
			</LayoutBlock>
			{!_.isEmpty(counters) && (
				<LayoutBlock>
					<Catalogs
						counters={counters}
						subtitle={catalogsText && catalogsText.text}
					/>
				</LayoutBlock>
			)}
			{!_.isEmpty(broadcast) && (
				<LayoutBlock>
					<Broadcast
						entities={broadcast}
						subtitle={broadcastText && broadcastText.text}
					/>
				</LayoutBlock>
			)}
			{firstCompilation && (
				<LayoutBlock>
					<Movies
						title={firstCompilation.title}
						subtitle={firstCompilation.shortText}
						entities={firstCompilation.mentionedEntities.movies}
					/>
				</LayoutBlock>
			)}
			{!_.isEmpty(specialProjects) && specialProjects.length >= 5 && (
				<LayoutBlock theme="light">
					<SpecialProjects
						entities={specialProjects}
						subtitle={specialProjectsText && specialProjectsText.text}
					/>
				</LayoutBlock>
			)}
			{!_.isEmpty(filmsAndPerformances) && (
				<LayoutBlock>
					<Movies
						title="Фильмы и спектакли, которые можно посмотреть онлайн"
						subtitle={filmsAndPerformancesText && filmsAndPerformancesText.text}
						entities={filmsAndPerformances}
					/>
				</LayoutBlock>
			)}
			{secondCompilation && (
				<LayoutBlock>
					<Movies
						title={secondCompilation.title}
						subtitle={secondCompilation.shortText}
						entities={secondCompilation.mentionedEntities.movies}
					/>
				</LayoutBlock>
			)}
			{!_.isEmpty(blocks) && (
				<LayoutBlock theme="light">
					<Persons blocks={blocks} subtitle={personsText && personsText.text} />
				</LayoutBlock>
			)}
			{!_.isEmpty(promoBlocks) && (
				<LayoutBlock>
					<Container gutter="noMobile">
						<MainPromoBlocks blocks={promoBlocks} />
					</Container>
				</LayoutBlock>
			)}
			{!_.isEmpty(concerts) && (
				<LayoutBlock>
					<Movies
						title="Концерты"
						url="/live/music/concerts"
						entities={concerts}
						subtitle={concertsText && concertsText.text}
					/>
				</LayoutBlock>
			)}
			{!_.isEmpty(lections) && (
				<LayoutBlock>
					<Movies
						title="Лекции"
						url="/live/lectures/movies"
						entities={lections}
						subtitle={lectionsText && lectionsText.text}
					/>
				</LayoutBlock>
			)}
		</Layout>
	);
};

WatchTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	blocks: PropTypes.shape({
		broadcast: PropTypes.array.isRequired,
		concerts: PropTypes.array.isRequired,
		cinemaCompilations: PropTypes.array.isRequired,
		filmsAndPerformances: PropTypes.array.isRequired,
		lections: PropTypes.array.isRequired,
		promoBlocks: PropTypes.array.isRequired,
		specialProjects: PropTypes.array.isRequired,
		searchPrompts: PropTypes.array.isRequired
	}).isRequired,
	counters: PropTypes.object.isRequired,
	textBlocks: PropTypes.shape({
		broadcastText: TextBlockPropType.isRequired,
		catalogsText: TextBlockPropType.isRequired,
		concertsText: TextBlockPropType.isRequired,
		personsText: TextBlockPropType.isRequired,
		filmsAndPerformancesText: TextBlockPropType.isRequired,
		lectionsText: TextBlockPropType.isRequired,
		specialProjectsText: TextBlockPropType.isRequired
	}).isRequired,
	rubric: RubricPropType.isRequired,
	text: PropTypes.string,
	topPromoBlock: PromoBlockPropType
};

export default WatchTemplate;
